/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'NON_DISCRIMINATION_BASED_ON_RACE_ETHNIC_GROUP_SKIN_COLOR',
              'NON_DISCRIMINATION_BASED_ON_SEX_GENDER',
              'NON_DISCRIMINATION_BASED_ON_RELIGION',
              'NON_DISCRIMINATION_BASED_ON_POLITICAL_OPINION',
              'NON_DISCRIMINATION_BASED_ON_NATIONAL_EXTRACTION',
              'NON_DISCRIMINATION_BASED_ON_SOCIAL_ORIGIN',
              'NON_DISCRIMINATION_BASED_ON_DISABILITY',
              'NON_DISCRIMINATION_BASED_ON_HIV_AIDS_STATUS_REAL_OR_PERCEIVED_',
              'NON_DISCRIMINATION_BASED_ON_SEXUAL_ORIENTATION',
              'NON_DISCRIMINATION_BASED_ON_PREGNANCY_MATERNITY_STATUS',
              'NON_DISCRIMINATION_BASED_ON_MARITAL_STATUS',
              'NON_DISCRIMINATION_BASED_ON_AGE',
              'NON_DISCRIMINATION_BASED_ON_MEMBERSHIP_IN_WORKER_ORGANIZATIONS',
              'NON_DISCRIMINATION_BASED_ON_NATIONALITY_FOREIGN_MIGRANT_WORKER_',
              'NON_DISCRIMINATION_BASED_ON_FAMILY_RESPONSIBILITIES',
              'NON_DISCRIMINATION_IN_RECRUITMENT_AND_HIRING',
              'NON_DISCRIMINATION_IN_COMPENSATION_AND_PROMOTION',
              'NON_DISCRIMINATION_IN_WORKING_CONDITIONS',
              'NON_DISCRIMINATION_IN_DISCIPLINE',
              'NON_DISCRIMINATION_IN_TERMINATION',
              'UNCONSCIOUS_BIAS',
              'OTHER',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    which_of_the_following_topics_are_included_win_the_facs_written_4: valueSchema,
  },
}
